import script from "./ToasSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ToasSection.vue?vue&type=script&setup=true&lang=js"

import "./ToasSection.vue?vue&type=style&index=0&id=5daf28d5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5daf28d5"]])

export default __exports__